import { useQuery } from "@apollo/client";
import {
  CREATE_WAREHOUSE_LOCATION_TYPE,
  DELETE_WAREHOUSE_LOCATION_TYPE,
  UPDATE_WAREHOUSE_LOCATION_TYPE,
} from "../../../../graphql/mutation/WarehouseSite";
import { FETCH_WAREHOUSE_LOCATION_TYPES } from "../../../../graphql/query/WarehouseLocationType";
import useRefetchWhenVisible from "../../../../hooks/useRefetchWhenVisible";
import ActiveRecordsPanel from "../SiteManagement/components/ActiveRecordsPanel";
import { getLocationTypeDeleteDescription } from "../SiteManagement/helpers";

const EMPTY_LIST = [];
const NO_EXTRA_HEADERS = [];
const LOCATION_TYPE_QUERY_NAMES = ["FetchWarehouseLocationTypes"];

const LocationTypes = () => {
  useRefetchWhenVisible({ queryNames: LOCATION_TYPE_QUERY_NAMES });
  const { data, loading } = useQuery(FETCH_WAREHOUSE_LOCATION_TYPES, {
    variables: { input: { show: "all" } },
  });

  return (
    <div className="w-full px-4 py-8 sm:px-6 lg:px-8">
      <ActiveRecordsPanel
        addLabel="Add location type"
        createMutation={CREATE_WAREHOUSE_LOCATION_TYPE}
        createMutationName="createWarehouseLocationType"
        deleteLabel="Delete location type"
        deleteMutation={DELETE_WAREHOUSE_LOCATION_TYPE}
        deleteMutationName="deleteWarehouseLocationType"
        extraHeaders={NO_EXTRA_HEADERS}
        getCreateInput={values => ({ description: values.description })}
        getDeleteDescription={getLocationTypeDeleteDescription}
        loading={loading}
        records={data?.warehouseLocationTypes || EMPTY_LIST}
        refetchQueries={["FetchWarehouseLocationTypes", "FetchSiteLocations"]}
        title="Location types"
        updateMutation={UPDATE_WAREHOUSE_LOCATION_TYPE}
        updateMutationName="updateWarehouseLocationType"
      />
    </div>
  );
};

export default LocationTypes;
